import { createStore } from 'satcheljs';
var moveToStore = createStore('moveToFolderMenuStore', {
    findText: '',
    isFocusInSearchBox: false,
    newFolderViewState: null,
    shouldShowAllFolders: false,
})();
export default moveToStore;
//# sourceMappingURL=store.js.map